import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import WarningIcon from '@mui/icons-material/Warning';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Austin', 159, 'Office 365', 24),
  createData('Tokyo', 237, 'Sign in to office', 37),
  createData('Cork', 262, 'Microsogt Dynamics', 24),
];

const AlertaTransacciones = () => {
  return (
    <>
      <div
        className="flex-col bg-white m-10 rounded-lg mt-0 border-r border-b border-l border-gray-400 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r border-gray-400"
        style={{ margin: '20px 10px 10px 10px', height: '32vh' }}
      >
        <p className="p-10 font-medium">Alerta de transacciones</p>
        <TableContainer component={Paper} sx={{ height: '25vh', maxWidth: '98%', overflowY: 'auto', margin: '10px' }}>
          <Table aria-label="caption table">
            <TableHead style={{ backgroundColor: 'lightgray' }}>
              <TableRow>
                <TableCell align="left">Tiempo de la alerta</TableCell>
                <TableCell align="left">Locación</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.name}>
                  <TableCell align="left">
                    {' '}
                    <WarningIcon style={{ color: 'orange' }} /> 2/2/2023 8:01:00 AM
                  </TableCell>
                  <TableCell align="left">{row.fat}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default AlertaTransacciones;
